module.exports = __webpack_public_path__ + "static/media/avatar.710606db.png";